import React from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const initialValues = {
    name: data?.name || '',
  };

  const inputFields = [
    {
      name: 'name',
      label: 'Inspection Observation',
      type: 'text',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={
        data ? 'Update Inspection Observation' : 'Add Inspection Observation'
      }
      url={'inspection-observation'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="inspection-observation"
      inputFields={inputFields}
      data={initialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
